import { useState } from "react";
import Link from "next/link";
import CopyIcon from "@components/Svg/Socials/CopyIcon";
import OKIcon from "@components/Svg/Socials/OKIcon";
import TGIcon from "@components/Svg/Socials/TGIcon";
import TwitterIcon from "@components/Svg/Socials/TwitterIcon";
import VKIcon from "@components/Svg/Socials/VKIcon";
import useCopyToClipboard from "@src/hooks/useCopyToClipboard";
import { BlogSocialProps } from "./types";
import s from "./blog-social.module.scss";

const BlogSocial = ({ postLink, title }: BlogSocialProps) => {
    const [_value, copy] = useCopyToClipboard();
    const [copied, setCopied] = useState<any>({
        status: false,
        text: "Копировать"
    });

    const copyLink = () => {
        copy(postLink);
        setCopied({ status: true, text: "Cкопировано" });
        setTimeout(() => {
            setCopied({ status: false, text: "Копировать" });
        }, 3000);
    };

    return (
        <div className={s.SocialLinks}>
            <Link
                href={`https://vk.com/share.php?url=${postLink}`}
                rel="nofollow noreferrer"
                className={s.Link}
                target="_blank"
            >
                <VKIcon />
            </Link>
            <Link
                href={`https://t.me/share/url?url=${postLink}&text=${title}`}
                rel="nofollow noreferrer"
                className={s.Link}
                target="_blank"
            >
                <TGIcon />
            </Link>
            <Link
                href={`https://twitter.com/intent/tweet?text=${title + ": " + postLink}`}
                rel="nofollow noreferrer"
                className={s.Link}
                target="_blank"
            >
                <TwitterIcon />
            </Link>
            <Link
                href={`https://connect.ok.ru/offer?url=${postLink}&title=${title}`}
                rel="nofollow noreferrer"
                className={s.Link}
                target="_blank"
            >
                <OKIcon />
            </Link>
            <div
                className={[s.Link, s.Copy, copied.status && s.Copied].join(" ")}
                onClick={copyLink}
            >
                <CopyIcon />
            </div>
        </div>
    );
};

export default BlogSocial;